import React, { useEffect, useState } from 'react';
import { Button, Input, Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useSelector } from 'react-redux';
import LivraisonClientDetail from './livraison_detail/livraisonClientDetail/LivraisonClientDetail';
import config from '../../config';
import { NdoeToolbar, NdoeResponsiveTable } from '../../components/ndoe';
import { buildLivraisonColumns, renderLivraisonCard } from './livraisonShared';

// Livraisons du jour — composant embarqué (onglet de Livraison_detail + réutilisable).
const LivraisonJour = () => {
    const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [open, setOpen] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [idClient, setIdClient] = useState({});
    const user = useSelector((state) => state.user?.currentUser);
    const isAdmin = user?.role === 'admin';

    const fetchData = async () => {
      try {
        const { data } = await axios.get(`${DOMAIN}/api/livraison/livraisonDetailJour`);
        setData(data);
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    };

    useEffect(() => {
      fetchData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [DOMAIN]);

    const handleDelete = async (id) => {
      try {
        await axios.delete(`${DOMAIN}/api/livraison/livraisonDeleteDetail/${id}`);
        fetchData();   // refetch au lieu de recharger toute la page
      } catch (err) {
        console.log(err);
      }
    };

    const showClient = (id) => { setIdClient(id); setOpen(true); };
    const openView = (idCommande) => navigate(`/livraisonView/${idCommande}`);

    const columns = buildLivraisonColumns({ onClient: showClient, onView: openView, onDelete: handleDelete, isAdmin });

    const filteredData = data?.filter((item) =>
      item.nom_client?.toLowerCase().includes(searchValue.toLowerCase()) ||
      item.nom_commune?.toLowerCase().includes(searchValue.toLowerCase()) ||
      item.nom_livreur?.toLowerCase().includes(searchValue.toLowerCase())
    );

  return (
    <>
      <NdoeToolbar
        search={
          <Input.Search
            type="search"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            placeholder="Rechercher (client, commune, livreur)…"
            allowClear
          />
        }
      />

      <NdoeResponsiveTable
        data={filteredData}
        columns={columns}
        rowKey="id_detail_livraison"
        loading={loading}
        scroll={{ x: 'max-content' }}
        pagination={{ pageSize: 10 }}
        renderCard={(record) => renderLivraisonCard(record, { onView: openView, onDelete: handleDelete, isAdmin })}
        empty={{ icon: '🚚', title: 'Aucune livraison', text: "Aucune livraison aujourd'hui." }}
      />

      <Modal
        title="Information du client"
        centered
        open={open}
        onCancel={() => setOpen(false)}
        width={850}
        footer={[<Button key="annuler" onClick={() => setOpen(false)}>Annuler</Button>]}
      >
        <LivraisonClientDetail idClients={idClient} />
      </Modal>
    </>
  );
}

export default LivraisonJour
